import type { Fund, Metadata } from 'venn-api';
import { updateColumnMappingsByFundChange, updateMappingColumnState } from '../../../views/mapping/helpers';
import type { ICellRendererParams } from 'ag-grid-community';
import type { ReviewCellRendererProps } from '../helpers';

export interface UploaderMenuOption {
  value: string | number;
  label: string;
}
export const convertToTriggerableMenuOption = (input: Metadata<string | number>): UploaderMenuOption => ({
  value: input.id,
  label: input.name,
});

/**
 * Performs mapping update when a change is made in the uploader.
 * `values` should be an array with the following values in this order:
 * [appendId: string, currency: string, typeId: number, fund: Fund | string (optional)]
 * if the last argument is a Fund, it means the column maps to an existing fund
 * if it is a string, the columns maps to a new fund whose name is the given string
 *
 * @param rendererProps
 * @param values
 */
export const performMappingUpdate = (
  rendererProps: ICellRendererParams & ReviewCellRendererProps,
  values: (string | number | Fund)[],
) => {
  const { currentMapping, data, mode, onMappingChange } = rendererProps;
  const updated = updateMappingColumnState(
    {
      // TODO: This could be optimized to take one fewer parameter (columns can be omitted), but leaving this for backwards compatibility
      mapping: currentMapping,
      columns: currentMapping.columns,
      values,
      seriesId: data.seriesId,
    },
    updateColumnMappingsByFundChange,
    mode,
  );
  onMappingChange(updated);
};
